<template>
    <div class="frequency-set-type-cell">
        <frequency-set-type-badge
            :type="row.type"
            :data-test-id="`frequency-set-type-${row.id}`"
        />
    </div>
</template>

<script>
import FrequencySetTypeBadge from '@/components/FrequencySetTypeBadge.vue'

export default {
    components: {
        FrequencySetTypeBadge,
    },

    props: {
        row: {
            type: Object,
            required: true,
        },
    },
}
</script>
